import React from 'react'

const index = ({titulo}) => {
  return (
    <h1 id="height_view__titulo">{titulo}</h1>
  )
}

export default index